import { Dialogs } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import CreateItem from "../views/createItem/CreateItem.js"; // given a Relationship instance, make an update action that can be installed into molten
export default (apiName, objectType) => {
  const {
    tIcon,
    t
  } = I18N.ns(`openApi.${apiName}.CreateAction`);
  return {
    id: `blueprint.action.${apiName}.CreateItem`,
    name: 'Create Item',
    layout: {
      sort: 'item.create'
    },
    matches: [{
      client: [null, 'GroupScreen'],
      use: ['contextMenu', 'mobileActionBar'],
      objectType
    }, {
      client: ['MapBoxRolloverSelectionPointer', 'ListDataViewer'],
      use: ['contextMenu'],
      objectType
    }],
    isPrepared: cxt => {
      const {
        clientProps: {
          delegate
        }
      } = cxt;
      return delegate.canCreate() != null;
    },
    prepare: cxt => {
      const {
        clientProps: {
          delegate
        }
      } = cxt;
      return GlobalState.dispatch(delegate.requestCanCreate());
    },
    handles: cxt => {
      const {
        clientProps: {
          delegate
        }
      } = cxt;
      return delegate.canCreate();
    },
    appearance: ({
      context
    }) => {
      const {
        clientProps: {
          relationship
        }
      } = context;
      return {
        name: `Create ${relationship.blueprint.name}`,
        icon: tIcon('icon')
      };
    },
    perform: ({
      context
    }) => {
      const {
        clientProps: {
          relationship,
          objectType,
          delegate,
          parentItem
        }
      } = context;
      const reloadData = context.reloadData || context.clientProps.reloadData;
      Dialogs.show({
        component: CreateItem,
        props: {
          reloadData,
          relationship,
          objectType,
          delegate,
          parentItem,
          blueprint: relationship?.blueprint,
          titleIcon: tIcon('titleIcon')
        }
      });
    }
  };
};